<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./repeat/Navbar.vue";
import axios from "../../utils/axios";
import { ref, onMounted } from "vue";
const router = useRouter();
const newsList = ref([]);
const productList = ref([]);

onMounted(() => {
  getNewsList();
  getProductCategories();
});
const getNewsList = async () => {
  try {
    const response = await axios.get("/framework/news/list", {
      params: {
        pageSize: 5,
        num: 1,
      },
    });
    newsList.value = response.records;
  } catch (error) {
    console.error("获取新闻列表失败：", error);
  }
};
// 获取产品分类列表
const getProductCategories = async () => {
  try {
    const response = await axios.get("/framework/product/list/tree");
    console.log(response);

    productList.value = response || [];
  } catch (error) {
    console.error("获取产品分类失败：", error);
  }
};
</script>

<template>
  <div class="map">
    <div class="kong">
      <Header> </Header>
    </div>
    <div class="wrap">
      <div class="inner">
        <div class="title_box">
          <div class="title">
            <span class="title_b">{{ $t("system.home.footer.f_text_o") }}</span>
          </div>
        </div>
        <ul class="inner_list">
          <li>
            <h5 class="inner_item">
              <a>{{ $t("system.home.lianjie.text_a") }}</a>
            </h5>
            <div class="item_box">
              <!-- 产品数据 -->
            </div>
          </li>
          <li>
            <h5 class="inner_item">
              <a>{{ $t("system.home.lianjie.text_b") }}</a>
            </h5>
            <div class="item_box">
              <router-link to="/about/company">{{
                $t("system.home.lianjie.a_j")
              }}</router-link>
              <router-link to="/about/quality">{{
                $t("system.home.lianjie.a_k")
              }}</router-link>
              <router-link to="/about/efficient">{{
                $t("system.home.lianjie.a_l")
              }}</router-link>
              <router-link to="/about/digital">{{
                $t("system.home.lianjie.a_m")
              }}</router-link>
              <router-link to="/about/marketing">{{
                $t("system.home.lianjie.a_n")
              }}</router-link>
              <router-link to="/about/partner">{{
                $t("system.home.lianjie.a_o")
              }}</router-link>
              <router-link to="/about/social">{{
                $t("system.home.lianjie.a_p")
              }}</router-link>
            </div>
          </li>
          <li>
            <h5 class="inner_item">
              <a>{{ $t("system.map.news") }}</a>
            </h5>
            <div class="item_box">
              <router-link 
                v-for="news in newsList" 
                :key="news.id"
                :to="`/news/newpage/${news.id}`"
              >
                {{ $i18n.locale === 'zh-cn' ? news.title : news.titleEn }}
              </router-link>
            </div>
          </li>
          <li>
            <h5 class="inner_item">
              <a>{{ $t("system.home.lianjie.text_c") }}</a>
            </h5>
            <div class="item_box2">
              <router-link to="/contact/contactWay">{{
                $t("system.home.lianjie.a_q")
              }}</router-link>
              <!-- <router-link to="/contact/register">{{
              $t("system.home.lianjie.a_r")
              }}</router-link> -->
            </div>
          </li>
          <!-- <li>
            <h5 class="inner_item">
              <router-link to="/talentPlan">{{
                $t("system.home.lianjie.a_t")
              }}</router-link>
            </h5>
          </li> -->
        </ul>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.wrap {
  padding: 80px 0;
}
.inner {
  max-width: 70%;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
}
.title_box {
  text-align: center;
  margin-bottom: 70px;
}
.title {
  font-size: 24px;
  position: relative;
  font-weight: bold;
  line-height: 38px;
  color: #717171;
}
.title::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 18px;
  background: #eaeaea;
  border-radius: 0px 0px 3px 3px;
}
.title_b {
  display: inline-block;
  vertical-align: middle;
  background: #ffffff;
  position: relative;
  z-index: 1;
  width: auto;
  height: 38px;
  padding: 0 14px;
}
h5 {
  margin: 0;
}
.inner_list {
  font-size: 16px;
  width: 100%;
  height: auto;
}
.inner_item {
  font-size: 20px;
  position: relative;
  font-weight: bold;
  line-height: 28px;
}
.inner_item a {
  display: inline-block;
  vertical-align: middle;
  background: #ffffff;
  color: #3e3a39;
  position: relative;
  z-index: 1;
  padding-right: 14px;
}
.inner_item::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 6px;
  background: #eaeaea;
}
.item_box,
.item_box2 {
  display: flex;
  flex-wrap: wrap;
  margin-left: -20px;
  padding: 25px 0 50px;
  
  a {
    padding: 0 20px;
    color: #3e3a39;
    position: relative;
    margin-bottom: 10px;
    transition: color 0.3s ease;
    
    &:hover {
      color: #004080;
    }
    
    &:not(:last-child) {
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 1px;
        height: 13px;
        background: #d9d9d9;
      }
    }
  }
}

// 删除这些重复的选择器
// .item_box a:nth-child(1)::before,
// .item_box a:nth-child(2)::before,
.item_box a:nth-child(3)::before,
.item_box a:nth-child(4)::before,
.item_box a:nth-child(5)::before,
.item_box a:nth-child(6)::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 1px;
  height: 13px;
  background: #d9d9d9;
}
</style>
